<script setup lang="ts">
import type { Blocks, ContentResponseContent, Metadata } from 'types';

const props = defineProps<{
  blocks: Blocks;
  content: ContentResponseContent;
  metadata: Metadata;
}>();

const computedBlocks = computed(() => {
  return props.blocks.blocks || {};
});
</script>

<template>
  <main>
    <BlockList
      v-if="computedBlocks"
      :blocks="computedBlocks"
    />
  </main>
</template>
